/** Advisors page copy. EN mirrors SV until proper translations are added. */
export const advisorsTranslationsSv = {
    title: 'Rådgivare',
    columns: {
        name: 'Namn',
        financialAdvisorCount: 'Finansiell rådgivare, antal ggr',
        legalAdvisor: 'Legal rådgivare',
        issuingAgent: 'Utgivare',
    },
    details: {
        generalAbout: 'Allmänt om {{name}}',
        advisorFallback: 'rådgivare',
        placeholderTitle: 'Bolag',
        placeholderValue: 'Vad ska vi skriva här?',
        issuesAsAdvisor: 'Emissioner som rådgivare',
    },
    advisorTypes: {
        financial_advisor: 'Finansiell rådgivare',
        legal_advisor: 'Legal rådgivare',
        issuing_agent: 'Emissionsinstitut',
    },
    summary: {
        financialOnly: 'Rådgivare i {{count}} emissioner som finansiell rådgivare.',
        legalOnly: 'Rådgivare i {{count}} emissioner som legal rådgivare.',
        issuingAgentOnly: 'Rådgivare i {{count}} emissioner som emissionsinstitut.',
        financialAndLegal:
            'Rådgivare i totalt {{total}} emissioner som finansiell rådgivare ({{financial}}) och som legal rådgivare ({{legal}}).',
        financialAndIssuingAgent:
            'Rådgivare i totalt {{total}} emissioner som finansiell rådgivare ({{financial}}) och som emissionsinstitut ({{issuingAgent}}).',
        legalAndIssuingAgent:
            'Rådgivare i totalt {{total}} emissioner som legal rådgivare ({{legal}}) och som emissionsinstitut ({{issuingAgent}}).',
        allThree:
            'Rådgivare i totalt {{total}} emissioner som finansiell rådgivare ({{financial}}), legal rådgivare ({{legal}}) och emissionsinstitut ({{issuingAgent}}).',
        default: 'Rådgivare i emissioner',
    },
}
